import { render, staticRenderFns } from "./plan.vue?vue&type=template&id=7709cf35&scoped=true"
import script from "./plan.vue?vue&type=script&lang=js"
export * from "./plan.vue?vue&type=script&lang=js"
import style0 from "./plan.vue?vue&type=style&index=0&id=7709cf35&lang=less"
import style1 from "./plan.vue?vue&type=style&index=1&id=7709cf35&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7709cf35",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/saas_fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7709cf35')) {
      api.createRecord('7709cf35', component.options)
    } else {
      api.reload('7709cf35', component.options)
    }
    module.hot.accept("./plan.vue?vue&type=template&id=7709cf35&scoped=true", function () {
      api.rerender('7709cf35', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/setting/pricing/plan.vue"
export default component.exports